import { useCallback, useEffect, useState } from 'react';
import { useApiClient } from '../dz-api-client-provider';
import { usePartnerConfig } from '../dz-partner-config-provider';
export const usePreSoldMembershipId = ({ addressId }) => {
    const apiClient = useApiClient();
    const partnerConfig = usePartnerConfig();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [preSoldMembershipId, setPreSoldMembershipId] = useState('');
    const fetchPreSoldMembershipId = useCallback(async () => {
        var _a, _b, _c;
        try {
            const { data } = await apiClient.getPreSoldMembership({
                filter: { addressId },
            });
            setPreSoldMembershipId(((_c = (_b = (_a = data.data) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.preSoldMembershipId) || null);
            setLoading(false);
        }
        catch (e) {
            setError('Error fetching pre-sold membership');
        }
    }, [addressId]);
    useEffect(() => {
        if (addressId && partnerConfig.accessToPreSoldMemberships) {
            fetchPreSoldMembershipId();
        }
        else {
            setLoading(false);
        }
    }, [addressId, partnerConfig, fetchPreSoldMembershipId]);
    return {
        preSoldMembershipId,
        loading,
        error,
    };
};
